export default "__VITE_ASSET__BXB4U7xA__"